import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { HeaderComponent } from './header.component';
import { LandingHeaderComponent } from './landing-header/landing-header.component';
import { HomeHeaderComponent } from './home-header/home-header.component';

import { SearchComponent } from './search/search.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { NavigationComponent } from './navigation/navigation.component';

import { CategoriesService } from '../../services/categories.service';
import { CoreModule } from '../../core.module';
import { FeatureTogglerService } from '../../services/feature-toggler.service';
import { FeatureTogglerDirective } from '../../directives/feature-toggler.directive';
import { FormsModule } from '@angular/forms';
import { StoreService } from '../../services/store.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslateModule
  ],
  declarations: [
    HeaderComponent,
    NavigationComponent,
    SearchComponent,
    UserMenuComponent,
    LandingHeaderComponent,
    HomeHeaderComponent
  ],
  exports: [
    HeaderComponent,
    NavigationComponent,
    SearchComponent,
    UserMenuComponent
  ],
  providers: [
    RouterLink,
    CategoriesService,
    FeatureTogglerService,
    StoreService
  ]
})
export class HeaderModule { }



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/modules/header/header.module.ts